export const APP = {
  name: "Northwind AI",
  nameShort: "NorthwindAI",
  slug: "northwind-ai",
  //
  title: "AI Automation Web Services",
  titleLong: "Northwind AI - AI Automation Web Services",
  keywords: [
    "north wind",
    "northwind",
    "north wind ai",
    "northwind ai",
    "microsoft north wind",
    "microsoft northwind",
    "north wind database",
    "northwind database",
    "north wind db",
    "northwind db",
    "ai automation",
    "ai agent",
    "ai agents",
  ],
  description:
    "Transform repetitive business processes into smart, autonomous AI agents. Automate virtual workflows and Point-of-Sale (POS) systems with Northwind AI.",
  owner: "HWP Labs",
  creator: "Emmanuel Tugbeh",
  startData: "2026-01-30T20:12:35.000",
  launchData: "2026-02-14T09:00:00.000",
  //
  domain: "northwindai.org",
  website: "https://northwindai.org",
  socialPreview: "https://northwindai.org/social-preview.png",
  email: "no-reply@northwindai.org",
  tel: "+2348169960927",
  telDisplayText: "(+234)81 6996 0927",
  //
  whatsappSalesUrl: "https://wa.me/2348169960927",
  whatsappGroupUrl: "https://chat.whatsapp.com/HajjJPJ2HkE0rTTITv2FGm",
  whatsappCommunityUrl: "https://chat.whatsapp.com/Id9WYTRrbxAHcTUfr3F5jv",
  //
  repositoryName: "hwp-labs/northwind-ai",
  repositoryUrl: "https://github.com/hwp-labs/northwind-ai",
};
